var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5764_17875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.385 24.2148H15.615C15.0088 24.9968 14.0615 25.5 13 25.5C11.9386 25.5 10.9912 24.9968 10.385 24.2148Z",
    fill: "#1996A6",
    stroke: "#1996A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7852 3.38559V3.75619L24.2139 20.9025L23.8529 21.2485C23.853 21.2485 23.853 21.2485 23.853 21.2485C23.9255 21.3243 23.9459 21.4359 23.9048 21.5324C23.8636 21.6288 23.7689 21.6914 23.6641 21.6914H2.33594C2.23105 21.6914 2.1363 21.6288 2.09516 21.5324C2.05403 21.4359 2.07441 21.3243 2.14701 21.2485L1.78613 20.9025L2.14702 21.2485C4.3919 18.9075 5.6289 15.8302 5.6289 12.5867V10.918C5.6289 7.59904 7.83527 4.78346 10.8603 3.86397L11.2148 3.75619V3.38559V2.28516C11.2148 1.30126 12.0161 0.5 13 0.5C13.9839 0.5 14.7852 1.30126 14.7852 2.28516V3.38559ZM13.7137 3.58154L14.2617 3.63437V3.08384V2.28516C14.2617 1.589 13.6962 1.02344 13 1.02344C12.3038 1.02344 11.7383 1.589 11.7383 2.28516V3.08384V3.63437L12.2863 3.58154C12.5216 3.55884 12.7597 3.54688 13 3.54688C13.2403 3.54688 13.4784 3.55884 13.7137 3.58154Z",
    fill: "#FAB54E",
    stroke: "#1996A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6641 11.1798C23.5195 11.1798 23.4024 11.0626 23.4024 10.9181C23.4024 8.14046 22.3197 5.52658 20.3556 3.56248C20.2534 3.46027 20.2534 3.29458 20.3556 3.19236C20.4578 3.09017 20.6235 3.09018 20.7257 3.19236C22.79 5.25665 23.9258 7.99876 23.9258 10.9181C23.9258 11.0626 23.8086 11.1798 23.6641 11.1798Z",
    fill: "#1996A6",
    stroke: "#1996A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.64442 3.5625L5.64442 3.5625C3.68038 5.52659 2.59766 8.14047 2.59766 10.9181C2.59766 11.0626 2.48047 11.1798 2.33594 11.1798C2.19141 11.1798 2.07422 11.0626 2.07422 10.9181C2.07422 7.99873 3.21002 5.25667 5.27431 3.19238C5.37654 3.09015 5.54225 3.0902 5.64439 3.19235L5.64442 3.19238C5.74664 3.2946 5.74664 3.46028 5.64442 3.5625Z",
    fill: "#1996A6",
    stroke: "#1996A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5764_17875"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.5b0b8f274437c2701307fc10bd1410d1.svg";
export { ForwardRef as ReactComponent };